import React from "react";
import { Stack, Typography } from "@mui/material";

export const SectionTitle = ({ icon, title }) => (
  <Stack direction="row" alignItems="center" spacing={2.25} sx={{ mb: 4 }}>
    {icon}
    <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 0.2 }}>
      {title}
    </Typography>
  </Stack>
);

export const KvRow = ({ Icon, label, value, alignRight = false, theme }) => (
  <Stack direction="row" spacing={2.25} alignItems="flex-start">
    <Icon size={15} color={theme.palette.text.secondary} style={{ marginTop: 2 }} />
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={2}
      sx={{ width: "100%" }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: 13,
          fontWeight: 600,
          textAlign: alignRight ? "right" : "left",
          maxWidth: "68%",
        }}
      >
        {value}
      </Typography>
    </Stack>
  </Stack>
);